<div class="row">
  <div class="col-12">
    <div class="row justify-content-between align-items-center" id="page-title">
      <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">
        Enroll in PSP
      </h1>
    </div>
    <div class="row mb-2">
      <span class="col-12 col-lg-auto d-flex align-items-center small">
        <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
        <span [innerHTML]="'Start_8-1' | translator:'base'">
          Are you a <strong>driver</strong> looking for your own PSP record?
        </span>
        <a [routerLink]="['/driver/1']" (click)="scrollToTop()" name="Driver-record-request" id="Driver-record-request"
          [title]="'Start_8-2' | translator:'base'" class="ms-1">
          <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
        </a>
      </span>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <div class="card shadow-sm rounded-0 border-0">
          <div class="card-body">
            <app-complete-bar [step]="1" [totalSteps]="19"></app-complete-bar>
            <h2 [innerHTML]="'Wiz_Welcome' | translator:'base'">Welcome</h2>
            <p [innerHTML]="'Start_2' | translator:'base'">
              Answer the following questions to begin the enrollment process.
            </p>
            <hr />
            <fieldset class="mb-3">
              <legend class="form-label">
                <span [innerHTML]="'Start_3' | translator:'base'">Have you previously enrolled in PSP?</span>
                <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
              </legend>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" (click)="clearInput()" name="previouslyEnrolled"
                    id="Previously-enrolled-yes" value="true" [(ngModel)]="previouslyEnrolled" />
                  <span [innerHTML]="'Start_4_Yes' | translator:'base'">Yes</span>
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" (click)="clearInput()" name="previouslyEnrolled"
                    id="Previously-enrolled-no" value="false" [(ngModel)]="previouslyEnrolled" />
                  <span [innerHTML]="'Start_4_No' | translator:'base'">No</span>
                </label>
              </div>
              <div *ngIf="previouslyEnrolled === 'true'" class="alert alert-info mt-3 mb-0" id="alert_previous_yes"
                role="alert">
                <p class="mb-0">
                  <span [innerHTML]="'Start_7-1' | translator:'base'">Please</span>
                  <a routerLink="/customerSupport" (click)="scrollToTop()" [title]="'Start_7-2' | translator:'base'"
                    name="customerSupportPrevEnrolled" id="customerSupportPrevEnrolled" class="alert-link">
                    <span [innerHTML]="'Start_7-2' | translator:'base'">contact customer support</span>
                  </a>
                  <span [innerHTML]="'Start_7-3' | translator:'base'"> for assistance accessing your account</span>.
                </p>
              </div>
            </fieldset>
            <hr *ngIf="previouslyEnrolled === 'false'" />
            <fieldset class="mb-3" *ngIf="previouslyEnrolled === 'false'">
              <legend class="form-label">
                <span [innerHTML]="'Start_5_Txt' | translator:'base'">Do you have a USDOT number?</span>
                <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
              </legend>
              <div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="USDOT" id="USDOT-yes" value="true"
                      [(ngModel)]="haveUSDOT" />
                    <span [innerHTML]="'Start_4_Yes' | translator:'base'">Yes</span>
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="USDOT" id="USDOT-no" value="false"
                      [(ngModel)]="haveUSDOT" (change)="enrollmentService.newCustomer!.dotId = ''" />
                    <span [innerHTML]="'Start_4_No' | translator:'base'">No</span>
                  </label>
                </div>
              </div>
            </fieldset>
            <hr *ngIf="haveUSDOT === 'true'" />
            <div *ngIf="haveUSDOT === 'true'">
              <label class="form-label" for="dotNumber">
                <span [innerHTML]="'MACP46_7' | translator:'base'">USDOT number</span>
                <span class="text-danger text-center ms-1 fl" [title]="'Required' | translator:'base'">*</span>
              </label>
              <input type="text" size="8" [(ngModel)]="enrollmentService.newCustomer!.dotId" (keyup)="testDot()"
                name="dotNumber" id="dotNumber" [ngClass]="{
                          'bg-light': true,
                          'form-control': true,
                          'is-invalid': testedDOT && inUse && enrollmentService.newCustomer!.dotId !== '' && !inUseTesting
                        }" [ngbTooltip]="
                          testedDOT && inUse && enrollmentService.newCustomer!.dotId !== '' && !inUseTesting
                            ? translate('MACP46_9')
                            : null" maxlength="8" />
              <span class="help-block text-danger" *ngIf="DOTisDurity && !DOTRegexIsValid"
                [innerHTML]="'MACP46_8' | translator:'base'">
                USDOT number contains invalid value(s). Please use only numbers.
              </span>
              <span class="help-block text-danger" *ngIf="DOTisDurity && enrollmentService.newCustomer!.dotId === ''"
                [innerHTML]="'MACP46_8_1' | translator:'base'">
                USDOT number is required.
              </span>
              <span class="help-block text-danger" *ngIf="enrollmentService.newCustomer!.dotId!.length >= 8 "
                [innerHTML]="'USDOT_max' | translator:'base'">
                USDOT must be 8 characters or less.
              </span>
              <span class="help-block text-danger"
                *ngIf="testedDOT && inUse && enrollmentService.newCustomer!.dotId !== '' && !inUseTesting"
                [innerHTML]="'MACP46_9' | translator:'base'">
                This DOT number already exists in PSP. Please call PSP help at
                1-877-642-9499 or email us at <a href="mailto:PSPhelp@tylertech.com">PSPhelp&#64;tylertech.com</a>.
              </span>
              <span class="help-block" *ngIf="inUseTesting" [innerHTML]="'MACP46_10' | translator:'base'">
                <span class="fas fa-spinner fa-spin"></span>
                Please wait while we validate your DOT #...
              </span>

            </div>
            <hr *ngIf="haveUSDOT === 'false'" />
            <fieldset *ngIf="haveUSDOT === 'false'">
              <legend class="form-label">
                <span [innerHTML]="'Start_6_0' | translator:'base'">How does your company hire drivers?</span>
                <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
              </legend>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" name="customerType" id="Hire-drivers-directly"
                    [value]="customerType.AH" [(ngModel)]="enrollmentService.newCustomer!.customerType" />
                  <span [innerHTML]="'Start_6_1' | translator:'base'">We hire drivers directly</span>
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" name="customerType"
                    id="Screen-drivers-on-behalf-of-other-companies" [value]="customerType.ISP"
                    [(ngModel)]="enrollmentService.newCustomer!.customerType" />
                  <span [innerHTML]="'Start_6_2' | translator:'base'">We help our clients hire drivers</span>
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" name="customerType" id="not-sure" value="false"
                    [value]="customerType.NOTSure" [(ngModel)]="enrollmentService.newCustomer!.customerType" />
                  <span [innerHTML]="'Start_6_3' | translator:'base'">not sure</span>
                </label>
              </div>
            </fieldset>
            <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
              <div class="btn-group" role="group">
                <button
                  [routerLink]="(enrollmentService.newCustomer!.customerType === customerType.AH ? '/signup/2' : (enrollmentService.newCustomer!.customerType === customerType.ISP ? '/signup/3' : '/signup/4'))"
                  (click)="scrollToTop()" [attr.disabled]="pageValid()" class="btn btn-primary btn-strong"
                  [innerHTML]="'Continue' | translator:'base'" [title]="'Continue' | translator:'base'"
                  name="companyNext1" id="companyNext1">
                </button>
              </div>
              <div class="btn-group" role="group">
                <button routerLink="/signup/welcome" (click)="scrollToTop()" class="btn btn-outline-primary"
                  [title]="'Back' | translator:'base'" name="companyBack1" id="companyBack1">
                  <span [innerHTML]="'Back' | translator:'base'"></span>
                </button>
                <button routerLink="/" (click)="scrollToTop()" name="companyCancel1" id="companyCancel1"
                  class="btn btn-light" [innerHTML]="'Cancel' | translator:'base'"
                  [title]="'Cancel' | translator:'base'">
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="1" pageType="all"
        class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
    </div>
  </div>
</div>